import DocumentDownload from './DocumentDownload';

export default DocumentDownload;